import { MatchOfferDeclineGroup } from "@nkr/enums/match-offer-decline-group";
import { IListItem } from "./list-item";

export interface IMatchOfferDeclineReasonListItem extends IListItem {
    declineGroup: MatchOfferDeclineGroup,
    sortOrder: number,
    nextQuestionGroup: number,
    allowOtherText: boolean
}